import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import IntegrationBanner from "../../assets/images/integration/integrationBanner.png";
import IndustryLeaders from "../../components/industry-leaders/industry-leaders";
import faceBook from "../../assets/images/integration/facebook.svg";
import instaGram from "../../assets/images/integration/instagram.png";
import linkeDin from "../../assets/images/integration/Linkedin.svg";
import googleAdwords from "../../assets/images/integration/google_adwords.png";
import forms from "../../assets/images/integration/forms.svg";
import webtrials from "../../assets/images/integration/Webtrials.svg";
import makeMyTrip from "../../assets/images/integration/makeMyTrip.svg";
import bookingCom from "../../assets/images/integration/Booking-com.png";
import tripAdvisor from "../../assets/images/integration/tripadvisor.png";
import airBnB from "../../assets/images/integration/airbnb.svg";
import triVago from "../../assets/images/integration/trivago.png";
import agoDa from "../../assets/images/integration/agoda.svg";
import gmail from "../../assets/images/integration/gmail.png";
import outlook from "../../assets/images/integration/outlook.png";
import mailChimp from "../../assets/images/integration/mailchimp.svg";
import Cta from "../../components/cta/cta";
import Testimonials from "../../components/home/Testimonials";

const BannerSection = () => {
  const customGridTemplateColumns = "repeat(3, 1fr)";
  const customGap = "24px";
  return (
    <>
      <div className="integration-wrapper">
        <section className="int-banner">
          <div className="max-container">
            <div className="padd-90">
              <div className="grid-auto-fit align-items-center max-width950">
                <div>
                  <h1 className="heading39px roboto-bold mb10 text-color-131415">
                    Connect Your Favorite <br /> Tools and Platforms <br /> with
                    BeyondLeadz
                  </h1>

                  <p className="roboto-regular heading16px mb30">
                    BeyondLeadz offers seamless integrations with various <br />{" "}
                    applications and platforms to streamline your lead <br />{" "}
                    management process.
                  </p>

                  <NavLink
                    to={"/contact-us"}
                    className="common-btn-class main-btn-primary roboto-regular"
                  >
                    Contact us
                  </NavLink>
                </div>
                <div>
                  <img
                    src={IntegrationBanner}
                    className="img-responsive position-relative"
                    alt="Connect Your Favorite Tools and Platforms with BeyondLeadz"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <IndustryLeaders />

        <section className="inte-2">
          <div className="max-container">
            <div className="padd-90">
              <div className="text-center">
                <h2 className="roboto-bold mb10 heading29px">
                  Social Media Integration
                </h2>
                <p className="heading16px roboto-regular mb40">
                  Engage Your Audience Where They Are
                </p>
              </div>

              <div
                className="grid-auto-fit max-width950"
                style={{ "grid-gap": customGap }}
              >
                <div className="integration-box common-white-box">
                  <img
                    src={faceBook}
                    alt="Facebook"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>Facebook</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Launch targeted ads, schedule posts, and analyze engagement
                    all from one dashboard.
                  </p>
                </div>

                <div className="integration-box common-white-box">
                  <img
                    src={instaGram}
                    alt="Instagram"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>Instagram</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Share impactful visuals, run interactive campaigns, and
                    track performance to boost brand presence.
                  </p>
                </div>

                <div className="integration-box common-white-box">
                  <img
                    src={linkeDin}
                    alt="Linkedin"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>Linkedin</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Build professional connections, manage sponsored content,
                    and nurture leads with tailored outreach.
                  </p>
                </div>
              </div>

              <div className="text-center mt60">
                <h2 className="roboto-bold mb10 heading29px">
                  Google Integration
                </h2>
                <p className="heading16px roboto-regular mb40">
                  Maximize Your Online Visibility
                </p>
              </div>

              <div
                className="grid-auto-fit max-width950"
                style={{ "grid-gap": customGap }}
              >
                <div className="integration-box common-white-box">
                  <img
                    src={googleAdwords}
                    alt="Google Adwords"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>Google Adwords</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Launch targeted ads, manage budgets, and track ROI with
                    real-time insights.
                  </p>
                </div>

                <div className="integration-box common-white-box">
                  <img
                    src={forms}
                    alt="Forms"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>Forms</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Collect leads and customer information efficiently, feeding
                    them directly into your CRM.
                  </p>
                </div>

                <div className="integration-box common-white-box">
                  <img
                    src={webtrials}
                    alt="Webtrials"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>Webtrials</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Integrate your trial campaigns with ease, nurturing
                    prospects from initial interest to conversion.
                  </p>
                </div>
              </div>

              <div className="text-center mt60">
                <h2 className="roboto-bold mb10 heading29px">
                  OTA Platform Integration
                </h2>
                <p className="heading16px roboto-regular mb40">
                  For the Travel and Hospitality Industry
                </p>
              </div>

              <div
                className="grid-auto-fit max-width950"
                style={{
                  "grid-template-columns": customGridTemplateColumns,
                  "grid-gap": customGap,
                }}
              >
                <div className="integration-box common-white-box">
                  <img
                    src={makeMyTrip}
                    alt="MakeMyTrip"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>MakeMyTrip</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Capture leads and manage bookings directly in your CRM for
                    better customer follow-up.
                  </p>
                </div>

                <div className="integration-box common-white-box">
                  <img
                    src={bookingCom}
                    alt="Booking.com"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>Booking.com</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Sync reservations and guest information to personalize
                    service and enhance customer experience.
                  </p>
                </div>

                <div className="integration-box common-white-box">
                  <img
                    src={tripAdvisor}
                    alt="TripAdvisor"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>TripAdvisor</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Monitor reviews, manage inquiries, and track potential leads
                    from the world’s most trusted travel platform.
                  </p>
                </div>

                <div className="integration-box common-white-box">
                  <img
                    src={airBnB}
                    alt="Airbnb"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>Airbnb</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Integrate guest data and streamline communication to provide
                    a smooth guest experience.
                  </p>
                </div>

                <div className="integration-box common-white-box">
                  <img
                    src={triVago}
                    alt="Trivago"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>Trivago</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Optimize pricing strategies and track competition for
                    smarter marketing decisions.
                  </p>
                </div>

                <div className="integration-box common-white-box">
                  <img
                    src={agoDa}
                    alt="Agoda"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>Agoda</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Sync your Agoda listings and bookings for more streamlined
                    lead management and customer outreach.
                  </p>
                </div>
              </div>

              <div className="text-center mt60">
                <h2 className="roboto-bold mb10 heading29px">
                  Email Marketing Integration
                </h2>
                <p className="heading16px roboto-regular mb40">
                  Effortless Outreach with Maximum Impact
                </p>
              </div>

              <div
                className="grid-auto-fit max-width950"
                style={{ "grid-gap": customGap }}
              >
                <div className="integration-box common-white-box">
                  <img
                    src={gmail}
                    alt="Gmail"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>Gmail</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Sync your Gmail account for seamless email creation,
                    tracking, and automated responses directly from your CRM.
                  </p>
                </div>

                <div className="integration-box common-white-box">
                  <img
                    src={outlook}
                    alt="Outlook"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>Outlook</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Integrate with Outlook for a unified experience, sending and
                    managing emails without leaving the platform.
                  </p>
                </div>

                <div className="integration-box common-white-box">
                  <img
                    src={mailChimp}
                    alt="Mailchimp"
                    className="img-responsive item-logo"
                  />
                  <p className="heading16px roboto-regular mb10">
                    <strong>Mailchimp</strong>
                  </p>
                  <p className="heading15px roboto-regular">
                    Automate email campaigns, segment audiences, and analyze
                    performance—all within your Leadhead dashboard.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Cta
          heading="Reach Your Ideal Customer With Us"
          firstCta="/signup"
          firstCtaText="Subscribe Now"
          secondCta="/contact-us"
          secondCtaText="Contact us"
        />

        <Testimonials />
      </div>
    </>
  );
};
export default BannerSection;
